import TopPanel from './top-panel';
import TabsNavigation from './tabs-nav';
import TabContent from './tab-content';
import { rootActions } from '../data/store';
import { useDispatch } from 'react-redux';
import { MouseEvent } from 'react';

const Wrapper = () => {

    const dispatch = useDispatch();

    const close = () => {
        dispatch(
            rootActions.toggle({
                isOpened: false,
            })
        )
    };

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    return (
        <div className="top-menu-m__wrapper fixed top-0 bottom-0 w-screen h-screen">
            <div className="top-menu-m__overlay absolute w-screen h-screen top-0 left-0 right-0 bottom-0" onClick={ close }></div>
            <div className="top-menu-m__main bg-gray-900 text-gray-250 absolute top-0 left-0 right-0 bottom-0 w-screen h-screen" onClick={ stopPropagation }>
                <TopPanel />

                <div className="flex h-full" style={{
                    height: 'calc(100vh - 65px)',
                }}>
                    <TabsNavigation />
                    <TabContent />
                </div>
            </div>
        </div>
    )
};

export default Wrapper;